import React, { useState, useEffect, useContext } from "react";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';

import "./FormPorTalento.scss"
import FormBody from "../../molecules/form-body/FormBody";
import FormWizard from "../../molecules/form-wizard/FormWizard";
import arrowLeft from "../../../assets/images/icons/flecha-izq.png";
import Button from "../../atoms/button/button";
import Modal from "../../ui/modal/Modal";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import { saveForm, getToken } from "../../../services/formServices";
import { Link } from "gatsby";
import Loading from "../../atoms/loading/loading";


const FormPorTalento = (props : ReferenciaContenido) => {
    const [activeStep, setActiveStep] = useState<number>(0);
    const [formValues, setFormValues] = useState<any>({});
    const [isDisabledButton, setIsDisabledButton] = useState<boolean>(false);
    const [inputDisabled, setInputDisabled] = useState<string[]>([]);
    const [showModalCancelar, setShowModalCancelar] = useState(false);
    const [wizards, setWizards] = useState<any[]>([]);
    const [enableTreatment, setEnableTreatment] = useState<boolean>(false);
    const [showAgeAlert, setShowAgeAlert] = useState(false);
    const [congrats, setCongrats] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [disableStep, setDisableStep] = useState<boolean>(true);

    const contentfulData = props.referenciaFormularios[0];

    const handleSubmitForm = async () => {
        setIsLoading(true);
        try {
            const token = await getToken();
            const formattedDate = new Date().toLocaleDateString('es-ES');
        
            const transformValues = (values) => {
                return {
                ...values,
                requirementsPortalento: Array.isArray(values.requirementsPortalento) ? values.requirementsPortalento.join(', ') : values.requirementsPortalento,
                disability: Array.isArray(values.disability) ? values.disability.join(', ') : values.disability,
                };
            };
        
            const transformedValues = transformValues(formValues);
        
            const mappedData = {
                idForm: 20,
                answers: [
                    ...Object.entries(transformedValues).map(([key, value]) => ({
                        contentfulId: key,
                        answer: value,
                    })),
                    {
                        contentfulId: 'registerDate',
                        answer: formattedDate,
                    },
                    {
                        contentfulId: 'fecha_mentoria',
                        answer: ' ',
                    }
                ],
            };
            saveForm(mappedData, token).then((response)=>{
                if (response.data.status === 200) {
                    setIsLoading(false);
                    setCongrats(true);
                }
            });
        } catch (error) {
            setIsLoading(false);
            setActiveStep(0);
        }
    }

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    }

    const closeCancelForm = () => {
        setShowModalCancelar(false);
    };

    const updateInputValue = (field: string, value: any, type?: string) => {
        setEnableTreatment(field === "dataAuthorization" && value === 'No acepto la política de datos');
        setIsDisabledButton(field === "dataAuthorization" && value === 'No acepto la política de datos');
        if (field === "birthDate" && !formValues.birthDate) {
            const today = new Date();
            const [day, month, year] = value.split('-').map((part: string) => parseInt(part, 10)); 
            const birthDate = new Date(year, month - 1, day);
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();
    
            // Calcula si la persona es menor o igual a 16 años
            if (age < 16 || (age === 16 && (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)))) {
                setFormValues((prev: any) => ({ ...prev, [field]: "" }));
                setShowAgeAlert(true);
                setIsDisabledButton(true);
                return;
            } else {
                setShowAgeAlert(false);
                setIsDisabledButton(false);
                return setFormValues((prev: any) => ({ ...prev, [field]: value }));
            }        
        }
        if (field === "mobile" || field === "auxNumber") {
            if (value.length !== 10 && value) {
                setIsDisabledButton(true);
            } else {
                setIsDisabledButton(false);
            }
        }
        setFormValues((prev: any) => {
           return { ...prev, [field]: value };
        });
    }
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < contentfulData.titulosFormulario.length-1; i++) {
            if (contentfulData.titulosFormulario[i]) {
                newWizards.push({
                    description: contentfulData.titulosFormulario[i+1].tituloGeneral,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    useEffect(() => {
        createWizards();
    }, []);

    return (
        <section>
            <div className="o-form-por-talento">
                {!congrats && !isLoading && (<div className="o-form-por-talento__banner">
                    <h1 className="o-form-por-talento__banner-title">Por Talento</h1>
                    <span className="o-form-por-talento__banner-breadcrumb">
                        <Link to="../">Por Talento</Link> / <strong>Inscripción</strong>
                    </span>
                    {window.innerWidth <= 768 && 
                        activeStep !== 0 &&
                            <div className="o-form-por-talento__wizard-mobile">
                                <h4 className="o-form-por-talento__wizard-mobile-title">Proceso de inscripción</h4>
                                <p className="o-form-por-talento__wizard-mobile-text">Paso {activeStep} de {contentfulData.titulosFormulario.length-1}: <span className="o-form-por-talento__wizard-mobile-text--bold">{contentfulData.titulosFormulario[activeStep]?.tituloGeneral}</span></p>
                            </div>
                    }
                    {window.innerWidth > 768 && activeStep !== 0 &&
                        <>
                            <div className="o-form-por-talento__banner-line"></div>
                            <h3 className="o-form-por-talento__wizard-text">Proceso de inscripción</h3>
                            <FormWizard wizards={wizards} activeIndex={activeStep-1} setActiveIndex={setActiveStep} />
                            <h4 className="o-form-por-talento__wizard-title-text--bold">
                                Paso {activeStep} de 4: <span className="o-form-por-talento__wizard-mobile-text--bold">{contentfulData.titulosFormulario[activeStep]?.tituloGeneral}</span>
                            </h4>
                            <div className="o-form-por-talento__advice-mandatory">
                                {contentfulData.descripcion.json && contentfulRenderOptions(contentfulData.descripcion.json)}
                            </div>
                        </>
                    }
                    {activeStep === 0 &&  
                        <>
                            <p className="o-form-por-talento__banner-description">Bienvenido al proceso de inscripción de Inclusión laboral para personas con discapacidad</p>
                            <p className="o-form-por-talento__banner-descriptionaux">Te acompañamos para que te conectes con oportunidades de empleo.</p>
                        </>
                    }
                </div>)}
                {!congrats && !isLoading && (
                    <div className="o-form-por-talento__form-container">
                        {window.innerWidth <= 768 && 
                            activeStep !== 0 &&
                                <div className="o-form-por-talento__wizard-mobile_arrows">
                                    <div className="o-form-por-talento__wizard-mobile_arrows-button-container">
                                        <button className="o-form-por-talento__wizard-mobile_arrows-button" onClick={handleBack}><img className="o-form-por-talento__form-back-arrow" src={arrowLeft} alt="Flecha izquierda"/>{activeStep == 1 ? "Requisitos" : `Paso ${activeStep-1}`}</button>
                                        {activeStep <= contentfulData.titulosFormulario.length-1 && (
                                            <button 
                                                type="button"
                                                className={`o-form-por-talento__wizard-mobile_arrows-button`}
                                                onClick={() => setActiveStep(activeStep + 1)}
                                                disabled={disableStep}
                                            >
                                                Paso {activeStep+1}
                                                <img 
                                                    className="o-form-por-talento__form-forward-arrow" 
                                                    src={arrowLeft} 
                                                    alt="Flecha derecha"
                                                />
                                            </button>
                                        )}
                                    </div>
                                </div>
                        }
                        {window.innerWidth > 768 && contentfulData.titulosFormulario[activeStep] &&
                            <>
                                <div className="o-form-por-talento__img-container light">
                                    <img className="o-form-por-talento__form-img" src={contentfulData.titulosFormulario[activeStep]?.imagenPrincipal?.file.url} alt="Imágen ilustrativa por talento."/>
                                </div>
                                <div className="o-form-por-talento__img-container dark">
                                    <img className="o-form-por-talento__form-img" src={contentfulData.titulosFormulario[activeStep]?.listaImagenes[0]?.file.url} alt="Imágen ilustrativa por talento."/>
                                </div>
                            </>
                        }
                        {window.innerWidth <= 768 && activeStep === 0 && contentfulData.titulosFormulario[activeStep] && 
                            <>
                                <div className="o-form-por-talento__img-container light">
                                    <img className="o-form-por-talento__form-img" src={contentfulData.titulosFormulario[activeStep]?.imagenPrincipal?.file.url} alt="Imágen ilustrativa por talento."/>
                                </div>
                                <div className="o-form-por-talento__img-container dark">
                                    <img className="o-form-por-talento__form-img" src={contentfulData.titulosFormulario[activeStep]?.listaImagenes[0]?.file.url} alt="Imágen ilustrativa por talento."/>
                                </div>
                            </>
                        }
                        {<div className="o-form-por-talento__inner-form-container">
                            {window.innerWidth <= 768 && 
                                <div className="o-form-por-talento__inner-form-description">
                                    {contentfulData.descripcion.json && contentfulRenderOptions(contentfulData.descripcion.json)}
                                </div>
                            }
                            {contentfulData.titulosFormulario[activeStep]?.descripcion && 
                                <div className="o-form-por-talento__inner-form-title">
                                    {documentToReactComponents(contentfulData.titulosFormulario[activeStep].descripcion.json)}
                                </div>
                            }
                            {contentfulData?.titulosFormulario &&
                                <FormBody
                                    titulosFormulario={contentfulData?.titulosFormulario}
                                    genericClassNameForm="formulario por talento"
                                    formValues={formValues}
                                    handleSubmitForm={handleSubmitForm}
                                    setInputValue={updateInputValue}
                                    inputDisabled={inputDisabled}
                                    isDisabledButton={isDisabledButton}
                                    setCurrentIndex={setActiveStep}
                                    currentIndex={activeStep}
                                    alertMessage={enableTreatment}
                                    ageAlert={showAgeAlert}
                                    setDisableStep={setDisableStep}
                                >
                                    <button
                                        className={`o-form-por-talento__form-cancel ${isLoading || activeStep === 0 ? "__none" : ""}`}
                                        onClick={() => setShowModalCancelar(true)}
                                    >
                                        Cancelar
                                    </button>
                                </FormBody>
                            }
                        </div>}
                        {showModalCancelar && (
                            <Modal
                                showModal={showModalCancelar}
                                onClose={closeCancelForm}
                            >
                                <div className={`o-form-por-talento__modal`}>
                                    <h3>¿Estás seguro que quieres cancelar la inscripción?</h3>
                                    <div className="o-form-por-talento__modal-buttons">
                                        <div className="o-form-por-talento__modal-cancelar">
                                            <Button
                                                type="button"
                                                classname="a-button-magenta_white"
                                                text={"Continuar mi inscripción"}
                                                isDisabled={false}
                                                onClickAction={() => {
                                                    closeCancelForm()
                                                }}
                                            >
                                            </Button>
                                        </div>
                                        <div className="o-form-por-talento__modal-continuar">
                                            <Button
                                                type="button"
                                                classname="a-button-magenta_transparent"
                                                text={"Cancelar mi inscripción"}
                                                isDisabled={false}
                                                onClickAction={() => {
                                                    closeCancelForm()
                                                }}
                                            >
                                            </Button>

                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        )}
                    </div>
                )}
                {isLoading && (
                    <div className="loading">
                        <Loading />
                    </div>
                )}
                {/* ventana de finalización de inscripción */}
                {congrats && (
                    <section className="o-form-por-talento__confimation-banner">
                        <img 
                            src="https://images.ctfassets.net/203frbsx1z3n/3me4UiL6WU9ZlQjxtv3AGc/5a045743eaf9c5df0a76b9fd92ce4c87/Grupo_16830.svg"
                            alt="Imagen de confirmación inscripción a por talento."
                            className="o-form-por-talento__confirmation-img light"
                        />
                        <img 
                            src="https://images.ctfassets.net/203frbsx1z3n/48M1YQqn7UtXBPRwtwaT5Z/da77924f1aaf80f278ed4f1af3c3a1bb/Grupo_16794.svg"
                            alt="Imagen de confirmación inscripción a por talento."
                            className="o-form-por-talento__confirmation-img dark"
                        />
                        <h1 className="o-form-por-talento__confirmation-title">¡Felicidades!</h1>
                        <span className="o-form-por-talento__confirmation-text">Nos emociona que hayas completado tu inscripción.</span>
                        <b className="o-form-por-talento__confirmation-bold-text">Revisaremos la información y nos comunicaremos contigo para brindarte más detalles sobre tu proceso.</b>
                        <div className="o-form-por-talento__confirmation-container">
                            <p className="o-form-por-talento__confirmation-text">Si necesitas más información estos son nuestros canales de atención:</p>
                            <span className="o-form-por-talento__confirmation-text"> Correo electrónico  <a className="o-form-por-talento__confirmation-anchor" href="mailto:portalentocolombia@comfama.com.co">portalentocolombia@comfama.com.co</a></span>
                            <span className="o-form-por-talento__confirmation-text">WhatsApp <a className="o-form-por-talento__confirmation-bold-text" href="https://wa.me/3103016666">310 301 6666 opciones 4 - 9</a></span>
                        </div>
                        <Link to="/personas/proyectos-inclusion-laboral/por-talento/" className="o-form-por-talento__confirmation-link">Finalizar</Link>
                    </section>
                )}
            </div>
        </section>
    );
}

export default FormPorTalento;